export default "__VITE_ASSET__BZzHArlZ__"